export default __webpack_public_path__ + "static/media/background_aae_hud_factory.a1f8535e.jpg";